export const FREE_TRIAL_DAYS = 14;

export const PRO_PLAN_HANDLE = 'pb2610-pro';

export const PLUS_PLAN_HANDLE = 'pb2610-plus';
